import { LiabilityShareOwnershipType } from '/@/modules/liability/enums/LiabilityShareOwnershipType';

export class LiabilityOwnershipMeta {
  /**
   * @var {string}
   */
  shareOwnershipType;

  constructor(model = {}) {
    this.shareOwnershipType = model.shareOwnershipType;
  }

  /**
   * @var {boolean}
   */
  get isSoleOwnership() {
    return this.shareOwnershipType === LiabilityShareOwnershipType.SOLE.key;
  }

  /**
   * @var {boolean}
   */
  get isJointOwnership() {
    return this.shareOwnershipType === LiabilityShareOwnershipType.JOINT.key;
  }

  /**
   * @var {boolean}
   */
  get isJointSurvivorshipOwnership() {
    return (
      this.shareOwnershipType === LiabilityShareOwnershipType.JOINT_WITH_SURVIVORSHIP_RIGHT.key
    );
  }
}
